module.exports = __webpack_public_path__ + "img/wx.82387b4c.png";